import type { PaletteBootstrap } from './types';

export const paletteBootstrap: PaletteBootstrap = {
	amBlue: {
		darken80: '#020d1f',
		darken60: '#052C64',
		darken40: '#084298',
		darken20: '#0B58CA',
		base: '#0d6efd',
		lighten20: '#0C6DFD',
		lighten40: '#3D8BFD',
		lighten60: '#6EA7FD',
		lighten80: '#9EC5FE',
		lighten90: '#CFE1FE',
		lighten97: '#f8f9fc'
	},
	cyan: {
		darken80: '#032830',
		darken60: '#055160',
		darken40: '#06798F',
		darken20: '#07A2C0',
		base: '#0dcaf0',
		lighten20: '#10CAF0',
		lighten40: '#37BFDB',
		lighten60: '#6DDEF6',
		lighten80: '#9EEAF9',
		lighten90: '#CEF4FC',
		lighten97: '#f7fcfe'
	},
	frostedBlue: {
		darken80: '#142327',
		darken60: '#28464d',
		darken40: '#3d6874',
		darken20: '#518b9a',
		base: '#65aec1',
		lighten20: '#84becd',
		lighten40: '#a3ceda',
		lighten60: '#c1dfe6',
		lighten80: '#e0eff3',
		lighten90: '#f0f7f9',
		lighten97: '#fafdfd'
	},
	parme: {
		darken80: '#150330',
		darken60: '#290661',
		darken40: '#3D0A91',
		darken20: '#520DC1',
		base: '#6610f2',
		lighten20: '#661de3',
		lighten40: '#8540F5',
		lighten60: '#A270F7',
		lighten80: '#C19EFA',
		lighten90: '#E0CFFC',
		lighten97: '#fbfcfd'
	},
	mauve: {
		darken80: '#170D26',
		darken60: '#2B1A4D',
		darken40: '#3D0A91',
		darken20: '#59359A',
		base: '#6f42c1',
		lighten20: '#6F42C1',
		lighten40: '#8B67CD',
		lighten60: '#A98EDA',
		lighten80: '#C5B3E5',
		lighten90: '#E1D9F3',
		lighten97: '#fcfafd'
	},
	pink: {
		darken80: '#2B0A1B',
		darken60: '#561435',
		darken40: '#801F4F',
		darken20: '#AA2869',
		base: '#d63384',
		lighten20: '#D63384',
		lighten40: '#DD5C9D',
		lighten60: '#E685B5',
		lighten80: '#EFADCD',
		lighten90: '#F7D6E6',
		lighten97: '#fef8fb'
	},
	brick: {
		darken80: '#2C0B0F',
		darken60: '#58151C',
		darken40: '#831F29',
		darken20: '#B02A37',
		base: '#dc3545',
		lighten20: '#dc3d4d',
		lighten40: '#E35C6A',
		lighten60: '#E9868F',
		lighten80: '#F1AEB5',
		lighten90: '#F8D7D9',
		lighten97: '#fdfafa'
	},
	orange: {
		darken80: '#321904',
		darken60: '#643208',
		darken40: '#984C0B',
		darken20: '#CA6410',
		base: '#fd7e14',
		lighten20: '#fb8325',
		lighten40: '#FD9843',
		lighten60: '#FEB272',
		lighten80: '#FECBA1',
		lighten90: '#FFE5D0',
		lighten97: '#fefaf9'
	},
	yellow: {
		darken80: '#332602',
		darken60: '#664D04',
		darken40: '#997305',
		darken20: '#CB9A07',
		base: '#ffc107',
		lighten20: '#fdc312',
		lighten40: '#FFCD38',
		lighten60: '#FFD969',
		lighten80: '#FFE69C',
		lighten90: '#FFF2CD',
		lighten97: '#fffdf8'
	},
	green: {
		darken80: '#051C12',
		darken60: '#0B3622',
		darken40: '#0F5132',
		darken20: '#136B42',
		base: '#198754',
		lighten20: '#1e8a57',
		lighten40: '#479F76',
		lighten60: '#75B798',
		lighten80: '#A3CFBB',
		lighten90: '#D1E6DD',
		lighten97: '#fafdfb'
	},
	turquoise: {
		darken80: '#051C12',
		darken60: '#0B3622',
		darken40: '#0F5132',
		darken20: '#1AA179',
		base: '#20c997',
		lighten20: '#28cf9e',
		lighten40: '#4DD4AC',
		lighten60: '#78DFC0',
		lighten80: '#A5E9D5',
		lighten90: '#D2F4E9',
		lighten97: '#f7fcfc'
	},
	grey: {
		darken80: '#212529',
		darken60: '#343A3F',
		darken40: '#485056',
		darken20: '#6C757D',
		base: '#adb5bd',
		lighten20: '#b5bcc3',
		lighten40: '#CED4D9',
		lighten60: '#DEE2E6',
		lighten80: '#E9ECEF',
		lighten90: '#F8F9FA',
		lighten97: '#fafafa'
	}
};
